import { TagMd as c } from "./tags.js";
import { resolveComponent as d, openBlock as t, createElementBlock as r, createElementVNode as o, Fragment as m, renderList as p, normalizeClass as g, createCommentVNode as u, createVNode as h, withCtx as _, createTextVNode as f, toDisplayString as a } from "vue";
import { _ as x } from "./_plugin-vue_export-helper-dad06003.js";
const b = {
  name: "StepsProgress",
  components: {
    TagMd: c
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    stepsWithoutHidden() {
      return this.steps.filter((l) => !l.hideSteps);
    }
  }
}, y = { "aria-label": "Progress" }, v = {
  role: "list",
  class: "overflow-hidden flex flex-row lg:flex-col"
}, w = {
  key: 0,
  class: "absolute right-0 lg:right-auto lg:left-7 top-1/2 lg:top-auto lg:bottom-0 mr-1 lg:mr-0 -mt-px lg:mt-0 lg:mb-1 lg:-ml-px h-px lg:h-6 w-5 lg:w-0.5 bg-gray-200 dark:bg-neutral-800 rounded-sm",
  "aria-hidden": "true"
}, k = { class: "group relative flex items-center" }, S = { class: "hidden lg:flex ml-4 min-w-0 flex-col" }, C = { class: "ct-text-2 text-base font-medium" };
function H(l, N, T, V, W, s) {
  const i = d("TagMd");
  return t(), r("nav", y, [
    o("ol", v, [
      (t(!0), r(m, null, p(s.stepsWithoutHidden, (e, n) => (t(), r("li", {
        key: e.name,
        class: g([
          n !== s.stepsWithoutHidden.length - 1 ? "pr-7 lg:pr-0 lg:pb-8" : "",
          "relative",
          e.current ? "opacity-100" : "opacity-60"
        ]),
        "aria-hidden": "true"
      }, [
        n !== s.stepsWithoutHidden.length - 1 ? (t(), r("div", w)) : u("", !0),
        o("div", k, [
          h(i, {
            class: "w-14",
            current: e.current
          }, {
            default: _(() => [
              f(a(e.name), 1)
            ]),
            _: 2
          }, 1032, ["current"]),
          o("span", S, [
            o("span", C, a(e.title), 1)
          ])
        ])
      ], 2))), 128))
    ])
  ]);
}
const E = /* @__PURE__ */ x(b, [["render", H]]);
export {
  E as S
};
